import * as PIXI from "pixi.js";

import { EventSystem } from "@src/core/events/EventSystem";
import { Button } from "@src/core/ui/components/Button";
import { Popup } from "@src/core/ui/components/Popup";
import { gameEngine } from "@src/game/GameEngine";
import { constants } from "@src/game/Constants";

// NOTE: Maybe rename to rigs popup?
export class CheatsPopup extends Popup {
  protected title: string = "";
  public width: number = 0;
  public height: number = 0;

  private COLUMNS: number = 0;
  private _rigButtons: Button[] = [];

  protected initializeComponents(): void {
    this.title = "Cheats";
    this.width = 700;
    this.height = 700;

    this.COLUMNS = 3;
    this._rigButtons = [];

    super.initializeComponents();
  }

  public initializeContent(): void {
    // console.log("During init - this instance:", this);
    // console.log("During init - object ID:", this.view.uid); // or some unique identifier

    // TODO: Get the real bet array from the server response
    const rigLabels: string[] = Object.keys(gameEngine.gameInitialData.rigData);
    const rows: number = Math.ceil(rigLabels.length / this.COLUMNS);

    // Calculate button size and spacing based on content area
    const buttonSpacing: number = 20;
    const availableWidth: number =
      this.contentSizeX - buttonSpacing * (this.COLUMNS - 1);
    const buttonWidth: number = availableWidth / this.COLUMNS;
    const buttonHeight: number = 70;

    // Calculate total height used by the grid
    const totalGridHeight: number =
      rows * buttonHeight + (rows - 1) * buttonSpacing;

    // Start from TOP-LEFT of content area, but offset to center vertically
    const startX: number = -this.contentSizeX / 2 + buttonWidth / 2;
    const startY: number = -totalGridHeight / 2 + buttonHeight / 2; // Center the grid vertically

    for (let i = 0; i < rigLabels.length; i++) {
      const rigLabel: string = rigLabels[i];
      const row: number = Math.floor(i / this.COLUMNS);
      const column: number = i % this.COLUMNS;

      const selectBetButton = this._createSelectRigButton(
        buttonWidth,
        buttonHeight,
        rigLabel.toString(),
      );
      selectBetButton.setActive(false);
      this._rigButtons.push(selectBetButton);

      // Position from top-left, left-to-right
      const x = startX + column * (buttonWidth + buttonSpacing);
      const y = startY + row * (buttonHeight + buttonSpacing);

      selectBetButton.view.position.set(x, y);
      this.content.addChild(selectBetButton.view);
    }

    super.initializeContent();
  }

  private _createSelectRigButton(
    width: number,
    height: number,
    label: string,
  ): Button {
    const buttonBackgroundActive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundActive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    buttonBackgroundActive.stroke({ width: 3, color: 0xffffff });

    const buttonBackgroundInactive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundInactive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    // NOTE: In pixijs, if a graphics object doesnt have a fill property
    // than it can not be clicked
    // We utilize that functionality to make already selected buttons unselectable
    buttonBackgroundInactive.fill(0x000000);
    buttonBackgroundInactive.stroke({ width: 3, color: 0x333333 });

    const betLabel = new PIXI.Text({
      text: label,
      style: {
        fill: "#ffffff",
        fontSize: 30,
        fontWeight: "bold",
        fontFamily: "uiFont",
        align: "center",
      },
    });
    betLabel.anchor.set(0.5);

    const selectBetButton: Button = new Button(
      constants.UIButtonTypes.POPUP_BUTTON,
    );
    selectBetButton.activeGraphics = buttonBackgroundActive;
    selectBetButton.inactiveGraphics = buttonBackgroundInactive;
    selectBetButton.onClick = () => {
      console.log(this._rigButtons);
      this._rigButtons.forEach((button) => button.setActive(false));
      selectBetButton.setActive(true);

      EventSystem.invoke(constants.UIEvents.CLICKED_RIG_BUTTON, label);
      this.setVisible(false);
      selectBetButton.setActive(false);
    };

    selectBetButton.view.addChild(betLabel);

    return selectBetButton;
  }
}
